import request from '@/utils/request'

export function expireToken() {
  return request({
    url: '/expireToken',
    method: 'get',
  })
}

export function refreshToken() {
  return request({
    url: '/api/system/index/refresh_token',
    method: 'get',
  })
}
